module.exports = __webpack_public_path__ + "static/zukal-85971048515390e13547bfd48ad441f9.jpg";